var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-bookmark",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-bookmark1",
    serifid: "iconB-bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4,7.8c0,-1.925 0.061,-2.881 0.436,-3.616c0.383,-0.753 0.995,-1.365 1.748,-1.748c0.735,-0.375 1.691,-0.436 3.616,-0.436l4.4,0c1.925,0 2.881,0.061 3.616,0.436c0.753,0.383 1.365,0.995 1.748,1.748c0.375,0.735 0.436,1.691 0.436,3.616l-0,13.2c0,0.356 -0.19,0.686 -0.498,0.865c-0.308,0.179 -0.689,0.18 -0.998,0.003l-6.504,-3.716l-6.504,3.716c-0.309,0.177 -0.69,0.176 -0.998,-0.003c-0.308,-0.179 -0.498,-0.509 -0.498,-0.865l0,-13.2Zm2,0c0,0 0,11.477 0,11.477l5.504,-3.145c0.307,-0.176 0.685,-0.176 0.992,-0l5.504,3.145l0,-11.477c0,-1.436 0.061,-2.16 -0.218,-2.708c-0.192,-0.376 -0.498,-0.682 -0.874,-0.874c-0.549,-0.279 -1.272,-0.218 -2.708,-0.218l-4.4,-0c-1.436,-0 -2.16,-0.061 -2.708,0.218c-0.376,0.192 -0.682,0.498 -0.874,0.874c-0.279,0.548 -0.218,1.272 -0.218,2.708Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBBookmark);
export default __webpack_public_path__ + "static/media/iconB-bookmark.93f54c7704158bc7767b35b5bd27545c.svg";
export { ForwardRef as ReactComponent };